const MainTitle = ({ value, ...props }) => {
  return <h1 {...props}> {value} </h1>;
};
export default MainTitle;
